import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminOrganizationCharts = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.ORGANIZATION_CHARTS.GET_ALL, { params });
    return response.data;
};
export const getAdminOrganizationChartById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.ORGANIZATION_CHARTS.GET_BY_ID(id));
    return response.data;
};
export const createOrganizationChart = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.ORGANIZATION_CHARTS.CREATE, data);
    return response.data;
};
export const updateOrganizationChart = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.ORGANIZATION_CHARTS.UPDATE(id), data);
    return response.data;
};
export const deleteOrganizationChart = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.ORGANIZATION_CHARTS.DELETE(id));
    return response.data;
};

